"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PivotTransform = exports.AggregateTransform = exports.Transform = void 0;
const error_1 = require("../error");
class Transform {
    static deserialize(obj) {
        if (obj.type === 'aggregate')
            return AggregateTransform.deserialize(obj);
        else if (obj.type === 'pivot')
            return PivotTransform.deserialize(obj);
        throw new error_1.default('Invalid transform type');
    }
}
exports.Transform = Transform;
class AggregateTransform extends Transform {
    static deserialize(obj) {
        return new AggregateTransform(obj.idColumns, obj.aggregations);
    }
    constructor(idColumns, aggregations) {
        super();
        this.idColumns = idColumns;
        this.aggregations = aggregations;
    }
    serialize() {
        return {
            type: 'aggregate',
            idColumns: this.idColumns,
            aggregations: this.aggregations,
        };
    }
}
exports.AggregateTransform = AggregateTransform;
class PivotTransform extends Transform {
    static deserialize(obj) {
        return new PivotTransform(obj.idColumns, obj.pivotColumn, obj.aggregations);
    }
    constructor(idColumns, pivotColumn, aggregations) {
        super();
        this.idColumns = idColumns;
        this.pivotColumn = pivotColumn;
        this.aggregations = aggregations;
    }
    serialize() {
        return {
            type: 'pivot',
            idColumns: this.idColumns,
            pivotColumn: this.pivotColumn,
            aggregations: this.aggregations,
        };
    }
}
exports.PivotTransform = PivotTransform;
